"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signalOnboardingRelevantChange = exports.onOnboardingRelevantChange = void 0;
const listeners = new Set();
/**
 * Subscribe to „something a checklist step is derived from has just changed on the server".
 * Returns the unsubscribe.
 *
 * The onboarding steps are derived from data six unrelated features own (positions,
 * members, contracts, shifts, published shifts, terminals), and none of them knows about
 * onboarding. Rather than teach all of them, the websocket subscriptions that already carry
 * those changes fire this — see `app/websockets/index.tsx`. It carries no payload on
 * purpose: it is a „something changed, go look" nudge, and the checklist answers it by
 * re-reading `onboardingState` and re-deriving every step from that one query.
 *
 * Push rather than polling, which is the point: nothing fires unless work actually happened
 * in the workspace, and it covers work done in another tab, by a colleague or by a terminal
 * — the cases the 30s interval this replaced existed for.
 */
const onOnboardingRelevantChange = (listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
exports.onOnboardingRelevantChange = onOnboardingRelevantChange;
/**
 * Fired from the websocket handlers whose payload can complete a checklist step, and once
 * more on reconnect — a socket that was down missed events, and re-reading is the only way
 * to find out what happened while it was gone.
 *
 * Free when nobody is listening, which is every page except the checklist itself.
 */
const signalOnboardingRelevantChange = () => {
    listeners.forEach((listener) => listener());
};
exports.signalOnboardingRelevantChange = signalOnboardingRelevantChange;
